import { requestSubscription, graphql, Environment } from 'react-relay';
import { Disposable } from 'relay-runtime';
import { presenceHeartbeatSubscription } from './__generated__/presenceHeartbeatSubscription.graphql';

export function presenceHeartbeat(
    environment: Environment,
    userOrSellerId: string,
    onHeartbeatReceived: () => void
): Disposable {
    const subscription = graphql`
        subscription presenceHeartbeatSubscription($userOrSellerId: String!) {
            presence(userOrSellerId: $userOrSellerId) {
                recentOnlineDate
            }
        }
    `;

    return requestSubscription<presenceHeartbeatSubscription>(environment, {
        subscription,
        variables: { userOrSellerId },
        onNext: () => {
            onHeartbeatReceived();
        },
    });
}
